import { z } from 'zod';
/**
 * Tenant / Site (ośrodek) contracts for CTMS Domain 1.
 */
export const TenantDtoSchema = z.object({
    id: z.number().int().positive(),
    name: z.string().min(1).max(255),
    isActive: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
/** Minimal tenant representation embedded in auth and session tokens. */
export const AuthTenantDtoSchema = z.object({
    id: z.number().int().positive(),
    name: z.string().min(1).max(255),
});
export const CreateTenantRequestSchema = z.object({
    name: z.string().min(2, 'Nazwa ośrodka musi mieć minimum 2 znaki').max(255),
});
export const UpdateTenantRequestSchema = z.object({
    name: z.string().min(2, 'Nazwa ośrodka musi mieć minimum 2 znaki').max(255).optional(),
    isActive: z.boolean().optional(),
});
export const SwitchTenantRequestSchema = z.object({
    tenantId: z.number().int().positive('Wymagany poprawny identyfikator ośrodka'),
});
/** Wall-clock `GG:MM` shape (the visit scheduler uses the same clock). */
const TIME_OF_DAY_SHAPE = /^\d{2}:\d{2}$/;
/** Last bookable minute of the day — the scheduler's final 15-minute slot. */
const WORKING_HOURS_LAST_MINUTE = 23 * 60 + 45;
function minutesOfDay(value) {
    const [hours = '0', minutes = '0'] = value.split(':');
    return Number(hours) * 60 + Number(minutes);
}
function isWithinWorkingHours(value) {
    const [, minutes = '0'] = value.split(':');
    return Number(minutes) <= 59 && minutesOfDay(value) <= WORKING_HOURS_LAST_MINUTE;
}
/**
 * Working hours of the current site (D4a — feature core-tenant/site-working-hours).
 *
 * A `null` pair means "no declared window": the site then works the full day
 * (00:00–23:45) and legacy sites are never blocked by a missing value. Bounds
 * are the scheduler slots — the whole day up to 23:45.
 */
const WorkingHoursTimeSchema = z
    .string()
    .refine((value) => TIME_OF_DAY_SHAPE.test(value), 'Godzina pracy musi mieć format "GG:MM"')
    .refine((value) => !TIME_OF_DAY_SHAPE.test(value) || isWithinWorkingHours(value), 'Godzina pracy musi mieścić się w zakresie od "00:00" do "23:45"');
export const TenantSettingsDtoSchema = z.object({
    workingHoursFrom: WorkingHoursTimeSchema.nullable(),
    workingHoursTo: WorkingHoursTimeSchema.nullable(),
});
export const UpdateTenantSettingsRequestSchema = TenantSettingsDtoSchema.refine((value) => value.workingHoursFrom === null ||
    value.workingHoursTo === null ||
    minutesOfDay(value.workingHoursFrom) <= minutesOfDay(value.workingHoursTo), 'Godzina "od" nie może być późniejsza niż godzina "do"');
//# sourceMappingURL=tenants.schema.js.map